import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Routes from "./Routes/index";
import WhatsAppButton from "../../ClientApp/src/components/WhatsApp";
import TopButton from "../../ClientApp/src/components/TopButton";
import './assets/scss/theme.scss';
import { informationService } from "./api/getInformationService";
import CommonToastContainer from "./components/Common/CommonToastContainer";
import { useContext } from "react";
import AuthContext from "../src/Context/AuthContext";

function App() {
    const location = useLocation();
    const { toasts, removeToast } = useContext(AuthContext);
    useEffect(() => {
        const isLoggedIn = localStorage.getItem("token");
        const existingNumber = localStorage.getItem("salesPersonWA");

        if (!isLoggedIn && !existingNumber) {
            informationService.WaNumber();
        }
    }, []);

    const hideFloatingButtons = location.pathname.startsWith("/verifyMail");

    return (
        <React.Fragment>
            <CommonToastContainer toasts={toasts} removeToast={removeToast} />
            <Routes />
            {!hideFloatingButtons && (
                <>
                    <WhatsAppButton />
                    <TopButton />
                </>
            )}
        </React.Fragment>
    );
}

export default App;
